import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="order-table"
export default class extends Controller {
  connect() {
    console.log("orderTableController connected");
  }

  createDeliverySlips(event) {
    // No jQuery and ajax, just plain JavaScript
    event.preventDefault();
    const deliveredAt = document.getElementById("delivered_at").value;
    if (!deliveredAt) {
      alert("納品日を入力してください。");
      return;
    }

    const checkedOrders = Array.from(
      document.querySelectorAll("[name*=order_ids]:checked")
    );
    if (checkedOrders.length === 0) {
      alert("納品書を作成する注文を選択してください。");
      return;
    }

    if (checkedOrders.length > 30) {
      alert("一度に作成できる納品書は30件までです。");
      return;
    }

    if (!confirm("本当に納品書を作成して売上を計上しますか？")) return;

    checkedOrders.forEach((checkbox) => {
      const tr = checkbox.closest("tr");
      tr.classList.add("table-secondary");
    });

    const orderIds = checkedOrders.map((checkbox) => checkbox.value);

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/orders/create_order_slip";
    form.target = "_blank";

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const csrfInput = document.createElement("input");
    csrfInput.type = "hidden";
    csrfInput.name = "authenticity_token";
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);

    orderIds.forEach((id) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "order_ids[]";
      input.value = id;
      form.appendChild(input);
    });

    const deliveredAtInput = document.createElement("input");
    deliveredAtInput.type = "hidden";
    deliveredAtInput.name = "delivered_at";
    deliveredAtInput.value = deliveredAt;
    form.appendChild(deliveredAtInput);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  createOutsourcedOrderItems(event) {
    event.preventDefault();
    if (!confirm("本当に外注依頼を作成しますか？")) return;

    const checkedOrders = Array.from(
      document.querySelectorAll("[name*=order_ids]:checked")
    );
    if (checkedOrders.length === 0) {
      alert("外注依頼を作成する注文を選択してください。");
      return;
    }

    const orderIds = checkedOrders.map((checkbox) => checkbox.value);

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/orders/create_outsourced_order_items";
    form.target = "_blank";

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const csrfInput = document.createElement("input");
    csrfInput.type = "hidden";
    csrfInput.name = "authenticity_token";
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);

    orderIds.forEach((id) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "order_ids[]";
      input.value = id;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  checkAll(event) {
    event.preventDefault();
    document.querySelectorAll("[name*=order_ids]").forEach((checkbox) => {
      checkbox.checked = true;
    });
  }

  uncheckAll(event) {
    event.preventDefault();
    document.querySelectorAll("[name*=order_ids]").forEach((checkbox) => {
      checkbox.checked = false;
    });
  }

  showCancelledOrders(event) {
    event.preventDefault();
    document.querySelectorAll(".cancelled").forEach((row) => {
      row.style.display = row.style.display === "none" ? "" : "none";
    });
  }

  async createQuoteFromOrders(event) {
    // No jQuery and ajax use Stimulus, vanilla JS and fetch instead
    if (!confirm("本当に受付から見積を作成しますか？")) return;

    const order_ids = Array.from(
      document.querySelectorAll("[name*=order_ids]:checked")
    ).map((el) => el.value);

    if (order_ids.length === 0) {
      alert("見積を作成する受付を選択してください。");
      return;
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const response = await fetch(`/orders/create_quote`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ order_ids })
    });

    if (response.ok) {
      const data = await response.json();
      window.location.href = `/quotes/${data.quote_id}/edit`;
    } else {
      console.error("Failed to create quote from orders");
    }
  }

  createInstruction(event) {
    alert("この画面からの作業指示書作成動線が詰められいないと思います。");
  }
}
